<script setup>

import {computed, ref} from "vue";
import {settingsBreadcrumbsForKey} from './breadcrumbs';

const customUserAreaEnabled = ref(false)
const breadcrumbs = computed(() => settingsBreadcrumbsForKey('navigation:backOffice.sidebar.myCompany.settings.navigation'));

</script>
<template>
    <div>
        <frosted-bar :breadcrumbs="breadcrumbs">
            <div class="flex items-center justify-between space-x-4">
                <h1>{{ _mft('navigation:backOffice.sidebar.myCompany.settings.navigation') }}</h1>
            </div>
        </frosted-bar>

        <card-tabbed
            class="mt-8"
            :track-state="false"
        >
        <card-tabbed-tab
            value="website-navigation"
            :title="_mft('navigation:backOffice.sidebar.myCompany.settings.navigation.website')"
            :active="true"
        >
            <header-theme-manager
                location="website"
                container="div"
                class="mb-4"
            ></header-theme-manager>

            <hr class="my-4">

            <settings-navigation
                :title="_mft('navigation:backOffice.sidebar.myCompany.settings.navigation.items')"
                navigation-type="website"
            />
        </card-tabbed-tab>
        <card-tabbed-tab
            value="customer-area-navigation"
            :title="_mft('navigation:backOffice.sidebar.myCompany.settings.navigation.customerArea')"
        >
            <settings-custom-user-area
                label="Enable custom user area navigation"
                @userAreaEnabledChanged="customUserAreaEnabled = $event"
            />

            <header-theme-manager
                v-if="customUserAreaEnabled"
                location="customer_area"
                container="div"
                class="mb-4"
            ></header-theme-manager>

            <settings-navigation
                v-if="customUserAreaEnabled"
                class="pt-6 mt-6 border-t"
                :title="_mft('navigation:backOffice.sidebar.myCompany.settings.navigation.items')"
                navigation-type="customerarea"
            />
        </card-tabbed-tab>
        </card-tabbed>
    </div>
</template>
